// extracted by mini-css-extract-plugin
export default {"fadingEdges":"FadeOutEdges_fadingEdges__lVjPN"};